import React, { useEffect } from "react";
import * as apiUrl from "../../apiUrl";

function BrochureDownloadPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const brochure = params.get("brochure"); 

    if (email && brochure) {
      verifyAndDownload(email, brochure);
    }
  }, []);

  const verifyAndDownload = async (email, brochure) => {
    try {
      // ✅ Step 1: Verify status from backend
      const res = await fetch(
        `${apiUrl.apiUrl}/api/brochure/check?email=${encodeURIComponent(email)}`
      );
      const data = await res.json();

      if (data.success && data.verified) {
        // ✅ Step 2: Trigger actual download
        const downloadLink = document.createElement("a");
        downloadLink.href = `${apiUrl.apiUrl}/${brochure}`;
        downloadLink.download = "brochure.pdf";
        downloadLink.target = "_blank";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        alert("Email not verified or not found.");
      }
    } catch (error) {
      console.error("Download check failed:", error);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h3>Preparing your brochure download...</h3>
    </div>
  );
}

export default BrochureDownloadPage;
